import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import mainReducer from "./reducers/index";

const middleware = [thunk];
const store = createStore(mainReducer, composeWithDevTools(applyMiddleware(...middleware)));
export default store;
